import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { CgCloseO } from "react-icons/cg";
import RadarGraph from "./charts/RadarGraphBlenderSolo";

function UnitIngredSmall(props) {
  return (
    <div className="w-24">
      {/* Close Btn */}
      <CgCloseO
        name={props.ind}
        onClick={props.onClick}
        className="bg-white rounded-full text-2xl
                                    text-gray-700
                                    ring-[1px] ring-gray-700 ring-inset
                                    hover:ring-4 hover:ring-slate-100
                                    -mb-3 ml-20 relative z-10
                                    hover:cursor-pointer
                                    "
      />

      {/* Ingredient Posters */}

      {props.option && props.option.poster_link ? (
        <Tooltip
          title={
            <React.Fragment>
              <Typography color="inherit">{props.option.name}</Typography>
              <b>{"Genre: "}</b>
              <em>{props.option.genres}</em>
              <br />
              <b>{"Evaluation: "}</b>
              <em>{props.option.rating}</em>
            </React.Fragment>
          }
        >
          <img
            src={props.option.poster_link}
            alt={props.option.name}
            style={
              props.blenderData.length > 1
                ? // && dbData[blenderData[0].django_id].poster_link
                  { filter: "grayscale(90%)" }
                : { filter: "grayscale(0%)" }
            }
            className={`w-24 h-[160px]
                            object-cover object-center
                ${
                  props.blenderData.length > 1
                    ? // && dbData[blenderData[0].django_id].poster_link
                      "opacity-60"
                    : "opacity-100"
                } duration-700`}
          />
        </Tooltip>
      ) : (
        // {/* Ingredient Posters Placeholder*/}
        <Tooltip
          title={
            <React.Fragment>
              <Typography color="inherit">{props.option.name}</Typography>
              <b>{"Genre: "}</b>
              <em>{props.option.genres}</em>
              <br />
              <b>{"Evaluation: "}</b>
              <em>{props.option.rating}</em>
            </React.Fragment>
          }
        >
          <p
            className="w-48 h-[320px] py-36 bg-white shadow-xl
                        text-2xl font-extrabold italic"
          >
            {props.option.name}
          </p>
        </Tooltip>
      )}

      {/* Ingredient Radar Charts */}
      <div className="-mt-12 -mb-8">
        <RadarGraph
          data={props.radarChartData[props.ind]}
          showName={"closest show name"}
          refShowName={props.selectedOption[0].name}
          refShow={true}
          returnProximity={props.blenderData}
          color={props.colorCodes[props.ind]}
          hideLegend={true}
          labelFontSize={5}
          polarRadius="20%"
        />
      </div>
    </div>
  );
}

export default UnitIngredSmall;
